// extracted by mini-css-extract-plugin
module.exports = {"CategoryContainer":"NavbarCategories_CategoryContainer__ofn8M","ContainerSearch":"NavbarCategories_ContainerSearch__23hkH","buttonCall":"NavbarCategories_buttonCall__3bELr"};